// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"90931a54","238":"85dca4df","239":"c3abb8d3","455":"d520ae78"}[chunkId] + ".chunk.js";
};